import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-v-mainsss"},[_c(VNavigationDrawer,{attrs:{"value":_vm.drawer,"fixed":_vm.mobile,"temporary":_vm.mobile,"mobile-breakpoint":0,"app":"","clipped":"","width":_vm.widthDrawer},on:{"input":function($event){return _vm.$emit('change-drawer', $event)}}},[_vm._t("navigation-drawer")],2),_c('div',{staticClass:"custom-v-main",class:{
      'custom-side-panel': _vm.drawer && !_vm.mobile,
    },style:(_vm.cssVars)},[_c('div',{staticClass:"pa-1 pl-4"},[_vm._t("main")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }